import { faBook, faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import TableAdvanced from '../../../../../components/Tables/TableAdvanced/TableAdvanced'
import { useLang } from '../../../../../language'

export const TableAparatos = ({ data, loading, total, perPage, handleFormChange, formValuesSearch }: any) => {

    const navigate = useNavigate();

    const Lang = useLang()

    const [excluidos, setExcluidos] = useState([])
    const [incluidos, setIncluidos] = useState([])

    const [checkAll, setCheckAll] = useState(false)

    const selectAllItems = () => {
        setCheckAll(true)
        setIncluidos([])
        setExcluidos([])
    }

    const unselectAllItems = () => {
        setCheckAll(false)
        setIncluidos([])
        setExcluidos([])
    }

    const allActions = [
        {
            label: <span><FontAwesomeIcon icon={faPlus} className='me-2' />{Lang('NUEVO_APARATO')}</span>,
            action: () => navigate(`./nuevo`),
        },
    ]

    const allActionsPerLine = [
        {
            label: <FontAwesomeIcon icon={faBook} className='me' />,
            action: (id: any) => navigate(`./${id}`),
        }
    ]

    const handleChangeCheckAll = (e: any) => {

        if (e.target.checked) {

            selectAllItems()

        } else {

            unselectAllItems()
        }
    }

    const headersTable = [
        <small>{Lang('APARATO')}</small>,
        <small>{Lang('MODELO')}</small>,
        <small>{Lang('DESCRIPCION')}</small>,
        ''
    ]

    const dataLineTable = [
        {
            className: '',
            name: 'producto'
        },
        {
            className: '',
            name: 'modelo'
        },
        {
            className: '',
            name: 'descripcion'
        },
    ]

    const classNameRow = (item: any) => {

        return item['fechabaja'] ? 'tr-td-transparent tr-red' : ''
    }

    // ------------ Modal Horario Evento

    const [showModal_Alquiler, setShowModal_Alquiler] = useState<any>({
        value: false,
        payload: {}
    });

    const handleCloseModal_Alquiler = () => setShowModal_Alquiler({
        value: false,
        payload: {}
    });

    const handleShowModal_Alquiler = (payload: object) => setShowModal_Alquiler({
        value: true,
        payload
    });

    
    // ------------ Modal Alquileres

    const [showModal_Alquileres, setShowModal_Alquileres] = useState<any>({
        value: false,
        payload: {}
    });

    const handleCloseModal_Alquileres = () => setShowModal_Alquileres({
        value: false,
        payload: {}
    });

    const handleShowModal_Alquileres = (payload: object) => setShowModal_Alquileres({
        value: true,
        payload
    });


    return (
        <>
            <TableAdvanced>

                <TableAdvanced.Head
                    title={Lang('APARATOS')}
                    allActions={allActions}
                />

                <TableAdvanced.Body
                    headers={headersTable}
                    dataLineTable={dataLineTable}
                    data={data}
                    isLoading={loading}

                    excluidos={excluidos}
                    incluidos={incluidos}
                    setExcluidos={setExcluidos}
                    setIncluidos={setIncluidos}

                    checkAll={checkAll}
                    allActionsPerLine={allActionsPerLine}
                    checkMultiples={false}
                    classNameRow={classNameRow}
                />

                <TableAdvanced.Footer
                    total={total}
                    handleFormChange={handleFormChange}
                    formValuesSearch={formValuesSearch}
                    perPage={perPage}
                />

            </TableAdvanced>

        </>

    )
}
